// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import OntologyPage from "./pages/OntologyPage";
import AgentPage from "./pages/AgentPage.js";
import BaguaCameraPage from "./pages/BaguaCameraPage.js";
import CameraPage from "./pages/CameraPage.js";
import MapPage from "./pages/MapPage.js";
import PlanPage from "./pages/PlanPage.js";
import TestPage from "./pages/TestPage.js";
import AgentsPage from "./pages/AgentsPage.js";

import ProfilePage from "./pages/ProfilePage.js";
import DesignHarmonyPage from "./pages/DesignHarmonyPage.js";

import PinboardPage from "./pages/PinboardPage.js";
import LivingHarmonyPage from "./pages/LivingHarmonyPage.js";

import LivingHarmonyNavigator from "./components/LivingHarmonyNavigator.js";
import MeetHarmonyNavigator from "./components/MeetHarmonyNavigator.js";

import NewProjectPage from "./pages/NewProjectPage.js";

import LittleLibraryPage from "./pages/LittleLibraryPage.js";
import GettingStartedPage from "./pages/GettingStartedPage";

import ArticlePage from "./pages/ArticlePage.js";

import ChatSwingsetPage from "./pages/ChatSwingsetPage.js";

// ——— Prototype-specific components ———
import ProjectLayout from "./components/ProjectLayout";

import "./index.css";
import "./living_harmony.css";

function App() {
  return (
    <Router>
      <Routes>
        {/* Design workspace with navigator layout */}
        <Route path="/" element={<MeetHarmonyNavigator />}>
          <Route index element={<GettingStartedPage />} />
          <Route path="new-project" element={<NewProjectPage />} />
        </Route>

        <Route path="/new-project" element={<MeetHarmonyNavigator />}>
          <Route index element={<NewProjectPage />} />
        </Route>

        <Route path="/design" element={<LivingHarmonyNavigator />}>
          <Route index element={<DesignHarmonyPage />} />
        </Route>

        <Route path="/profile" element={<MeetHarmonyNavigator />}>
          {/* Nested route renders inside the navigator's <Outlet> */}
          <Route index element={<ProfilePage />} />
        </Route>

        <Route path="/ontology" element={<MeetHarmonyNavigator />}>
          {/* Nested route renders inside the navigator's <Outlet> */}
          <Route index element={<OntologyPage />} />
        </Route>

        <Route path="/swingset" element={<MeetHarmonyNavigator />}>
          {/* Nested route renders inside the navigator's <Outlet> */}
          <Route index element={<ChatSwingsetPage />} />
        </Route>

        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/pinboard" element={<PinboardPage />} />
        <Route path="/little_library" element={<LittleLibraryPage />} />
        <Route path="/living_harmony" element={<LivingHarmonyPage />} />
        <Route path="/agent/:projectId" element={<AgentPage />} />
        <Route path="/baguaCamera/:projectId" element={<BaguaCameraPage />} />
        <Route path="/camera/:projectId" element={<CameraPage />} />
        <Route path="/plan/:projectId" element={<PlanPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/test" element={<TestPage />} />
        <Route path="/article/:id" element={<ArticlePage />} />
      </Routes>
    </Router>
  );
}

export default App;
